
import { Navigate, useLocation } from 'react-router-dom'
import { useMediaQuery } from '@mui/material'

export const PublicRoutes = ({ children, isAuth, perfil }) => {

    const isMobile = useMediaQuery('(max-width:768px)');

    const location = useLocation();
    const state = location.state;

    let goToPage = state?.from || '/'

    if (goToPage === '/') {
        goToPage = isMobile ? '/projects' : (perfil === 9 ? '/projects' : '/inicio')
    }

    return isAuth ? <Navigate to={goToPage} replace={true} /> : children
}